import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import { containsNoValues } from 'src/util/object.helpers'
import {
  checkValidations,
  emailRule,
  passwordRule,
  requiredRule
} from 'src/util/validation/commonValidation.helpers'
import Login from '../../components/auth/login/Login'
import {
  SignupConfirmation,
  SignupVerificationSuccess
} from '../../components/popups/signUp'
import {
  DEFAULT_CONTAINER_STATE,
  SIGNUP_PROCESS_STEP
} from '../../constants/containerStates'
import { SIGNUP_URL } from '../../constants/navigation'
import requireUnauth from '../../hoc/requireUnauth'
import {
  changeLoginInputAndErrorState,
  changeLoginState,
  cleanLoginState,
  cleanSignupState,
  logIn,
  resendSignupEmail,
  socialMediaLogIn
} from '../../store/actions/auth'
import { LOGIN_PROFILE_DISPATCH } from '../../store/reducers/auth/login'
import { getForceSignup, removeForceSignup } from '../../util/local.helpers'

const LoginContainer = ({
  loginProfile,
  changeLoginState,
  changeLoginInputAndErrorState,
  cleanLoginState,
  logIn,
  resendSignupEmail,
  socialMediaLogIn,
  cleanSignupState,
  signupProfile
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    setPopupState(signupProfile.signupState)
  }, [signupProfile.signupState])

  const [popupState, setPopupState] = useState(DEFAULT_CONTAINER_STATE.NONE)

  const handleNoPopup = () => {
    setPopupState(DEFAULT_CONTAINER_STATE.NONE)
  }

  useEffect(() => {
    if (getForceSignup()) {
      navigate(SIGNUP_URL)
    }
    // cleanLoginState()
    return () => {
      cleanLoginState()
      removeForceSignup()
      cleanSignupState()
    }
  }, [])

  const onFormSubmit = () => {
    const { email, password } = loginProfile
    const errors = checkValidations({
      email: { value: email, rules: [requiredRule, emailRule] },
      password: { value: password, rules: [requiredRule, passwordRule] }
    })
    if (containsNoValues(errors)) {
      logIn(email, password)
    } else {
      changeLoginState(LOGIN_PROFILE_DISPATCH.ERROR, errors)
    }
  }

  const handleResendVerification = () => {
    const { email } = loginProfile
    resendSignupEmail(email)
  }

  const handleClosePopup = () => {
    cleanLoginState()
    cleanSignupState()
    handleNoPopup()
  }

  const handleSocialMediaLogin = (provider) => {
    socialMediaLogIn(provider)
  }

  const renderPopup = () => {
    switch (popupState) {
      case SIGNUP_PROCESS_STEP.SIGNUP_VERIFIED:
        return <SignupVerificationSuccess onSubmit={handleClosePopup} t={t} />
      case SIGNUP_PROCESS_STEP.CONFIRM_VERIFICATION_FAILED:
      case SIGNUP_PROCESS_STEP.RESEND_VERIFICATION_SUCCESS:
      case SIGNUP_PROCESS_STEP.RESEND_VERIFICATION_FAILED:
        const {
          error: { confirm },
          signupState
        } = signupProfile
        const params = {
          title: t('sign-up.confirmation-failed'),
          desc: t(confirm?.message),
          showResend: confirm?.showResend,
          isError: true
        }
        return (
          <SignupConfirmation
            signupState={signupState}
            onResendVerification={handleResendVerification}
            onCancel={handleClosePopup}
            t={t}
            {...params}
          />
        )

      default:
        break
    }
  }

  return (
    <>
      <Login
        loginProfile={loginProfile}
        onFormSubmit={onFormSubmit}
        dispatchAction={changeLoginInputAndErrorState}
        onResendVerification={handleResendVerification}
        onSocialMediaLogin={handleSocialMediaLogin}
        t={t}
      />
      {renderPopup()}
    </>
  )
}

const mapStateToProps = ({ authReducer }) => {
  const { loginProfile, signupProfile } = authReducer
  return {
    loginProfile,
    signupProfile
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeLoginState,
      changeLoginInputAndErrorState,
      cleanLoginState,
      logIn,
      resendSignupEmail,
      socialMediaLogIn,
      cleanSignupState
    },
    dispatch
  )

export default requireUnauth(
  connect(mapStateToProps, mapDispatchToProps)(LoginContainer)
)
